export default __webpack_public_path__ + "static/media/prepaidmetering.942de409.webp";